/**
 * Recover OTP (sendAccessCode)
 *
 * @param {Object} params
 * @returns
 */
export async function recoverSecurityOtp(params) {
  return fetch('/connect/recoverSecurityOtp', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => response.json())
    .catch((e) => {
      console.error(e);
      throw new Error('login.error_sendCredentials');
    });
}
